export default "__VITE_ASSET__NGr5fIq3__"